import { z } from "zod";

export const AD_MEDIA_ITEM_TYPES = ["image", "video"] as const;

const AD_MEDIA_ITEM_SOURCES = ["external", "internal"] as const;

const AD_MEDIA_ITEM_SCHEMA = z.object({
  type: z.enum(AD_MEDIA_ITEM_TYPES, "Media type is required"),
  source: z.enum(AD_MEDIA_ITEM_SOURCES, "Media source is required"),
  id: z.string().min(1, "ID is required"),
  src: z.string().min(1, "Source URL is required"),
  bunnyId: z.string().min(1, "Bunny ID is required").optional(),
});

const AD_INTERNAL_MEDIA_ITEM_SCHEMA = AD_MEDIA_ITEM_SCHEMA.extend({
  source: z.literal("internal"),
  key: z.string().min(1, "Image key is required"),
});

const AD_EXTERNAL_MEDIA_ITEM_SCHEMA = AD_MEDIA_ITEM_SCHEMA.extend({
  source: z.literal("external"),
});

export const AD_MEDIA_MAX_IMAGE_COUNT = 200;
export const AD_MEDIA_MAX_VIDEO_COUNT = 20;

export const AD_MEDIA_SCHEMA = z.object({
  images: z
    .array(AD_INTERNAL_MEDIA_ITEM_SCHEMA)
    .min(1, "At least one image is required")
    .max(
      AD_MEDIA_MAX_IMAGE_COUNT,
      `A maximum of ${AD_MEDIA_MAX_IMAGE_COUNT} images can be uploaded here, please contact us if you need more.`
    ),
  videos: z
    .array(
      z.union([AD_EXTERNAL_MEDIA_ITEM_SCHEMA, AD_INTERNAL_MEDIA_ITEM_SCHEMA])
    )
    .max(
      AD_MEDIA_MAX_VIDEO_COUNT,
      `A maximum of ${AD_MEDIA_MAX_VIDEO_COUNT} videos can be uploaded here, please contact us if you need more.`
    ),
});

export type AdMedia = z.infer<typeof AD_MEDIA_SCHEMA>;

export const AD_MEDIA_DEFAULTS: AdMedia = {
  images: [],
  videos: [],
};

export type AdMediaItemEditViewModel = z.infer<typeof AD_MEDIA_ITEM_SCHEMA>;
export type AdInternalMediaItemEditViewModel = z.infer<
  typeof AD_INTERNAL_MEDIA_ITEM_SCHEMA
>;
export type AdExternalMediaItemEditViewModel = z.infer<
  typeof AD_EXTERNAL_MEDIA_ITEM_SCHEMA
>;
export type AdMediaType = (typeof AD_MEDIA_ITEM_TYPES)[number];
